 import React from "react";
import { Link } from "react-router-dom";  
import { FaExclamationTriangle, FaCommentDots, FaHandsHelping } from "react-icons/fa";
import "./Homecard.css";

const HomeCards = () => {
  return (
    <div className="cards-container">
      
      <div className="eco-card report">
        <div className="icon-box">
          <FaExclamationTriangle />
        </div>
        <h3>Report Issue</h3>
        <p>
          Report pollution, waste issues or any environmental problem around you.
        </p>
        
        <Link to="/report">
          <button>Report Now</button>
        </Link>
      </div>

      <div className="eco-card feedback">
        <div className="icon-box">
          <FaCommentDots />
        </div>
        <h3>Feedback</h3>
        <p>
          Share your ideas and feedback to make EcoVibe better.
        </p>
         
        <Link to="/feedback">
          <button>Give Feedback</button>
        </Link>
      </div>

      <div className="eco-card volunteer">
        <div className="icon-box">
          <FaHandsHelping />
        </div>
        <h3>Join as Volunteer</h3>
        <p>
          Join our volunteers and help protect nature together.
        </p>
         
        <Link to="/join-as-volunteer">
          <button>Join Now</button>
        </Link>
      </div>

    </div>
  );
};

export default HomeCards;